import { Component, Input, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { FormControl } from '@angular/forms';
import { FiltersService } from './search-list/filters/filters.service';
import { BreadCrumb } from '../breadcrumb/bread-crumb';
import { BreadCrumbLocalStorageService } from "../breadcrumb/bread-crumb-local-storage.service";
import { HtmlUtilsService } from "../html-utils/html-utils.service";
import {FiltersComponent} from "./search-list/filters/filters.component"
import {UserQueryDtoInterface} from '../auth/account/user-queries/dto/user-query-dto';

@Component({
  selector: 'app-search-layout',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.css']
})
export class SearchComponent implements OnInit {

  @Input() phrase: string;

  phraseField = new FormControl();

  _searchInText: boolean;

  get searchInText() {
    return this._searchInText;
  }
  userQuery: UserQueryDtoInterface;

  breadcrumbs$: BreadCrumb[] = [];

  constructor(private location: Location,
    private router: Router,
    private route: ActivatedRoute,
    private filtersService: FiltersService,
    private breadCrumbService: BreadCrumbLocalStorageService,
    private htmlUtils: HtmlUtilsService,
    private filtersComponent: FiltersComponent) {
    this._searchInText = htmlUtils.searchInText;
  }

  ngOnInit() {
    this.breadCrumbService.routeChanged.subscribe(e => {
      e.forEach(element => {
        if (element.url.includes('queryId') && e[e.length - 1].label !== 'kwerenda') {
          element.label = 'queries';

          const newBreadCrumb = { label: "", step: 0, url: "", nameKwerenda: "" };
          newBreadCrumb.label = "kwerenda";
          newBreadCrumb.step = element.step + 1;
          newBreadCrumb.url = "";
          //newBreadCrumb.nameKwerenda = "\"\"";// {{userQuery.title}}
          e.push(newBreadCrumb);
        }
      });

      this.breadcrumbs$ = e;
      this.breadcrumbs$ = this.breadcrumbs$.slice();
    });

    this.phraseField.valueChanges.subscribe(value => {
      this.phrase = value;
    });
  }

  goBack() {
    this.location.back();
  }
}
